import React from 'react';
import _ from 'lodash';
import { Paginator } from '@/core/Paginator.molecule';
import { useFluxPath } from '@/core/hooks/useFluxPath.hook';
import { MIN_HOME_SCREEN_ITEM_COUNT } from '@/homescreen/homescreen.constants';

interface PaginationProps {
  loadTable: (offset: number, limit: number, searchParams?: any) => void;
  store: PaginationAndFilteringSupportingStore;
  actions: PaginationAndFilteringSupportingActions;
  tableType?: string;
  insideModal?: boolean;
}

export type PaginationAndFilteringSupportingStore = {
  getItemTotalForTable: (table?: string) => number;
  getPageSizeByTable: (table?: string) => number;
  getPageNumberForTable: (table?: string) => number;
  searchParams: object;
  sortProperty?: string;
  sortAscending?: boolean;
};

export type PaginationAndFilteringSupportingActions = {
  setPageSizeForTable: ({ size, table }: { size: number; table?: string }) => void;
  setPageNumberAndGo: (page: number, loadTable: (...args: any[]) => any, table?: string, searchParams?: object) => void;
};

export const Pagination: React.FunctionComponent<PaginationProps> = ({
  store,
  actions,
  tableType,
  loadTable,
  insideModal,
}) => {
  const totalResults = useFluxPath(store, (s) => s.getItemTotalForTable(tableType));
  const tablePageSize = useFluxPath(store, (s) => s.getPageSizeByTable(tableType));
  const pageNumber = useFluxPath(store, (s) => s.getPageNumberForTable(tableType));
  const searchParams = useFluxPath(store, (s) => s.searchParams);
  const pageCount = _.max([Math.ceil(totalResults / tablePageSize), 1]) as number;

  const setPageSizeInStoreAndTable = (size: number) => {
    actions.setPageSizeForTable({ size, table: tableType });
    actions.setPageNumberAndGo(1, loadTable, tableType, searchParams);
  };

  return totalResults > MIN_HOME_SCREEN_ITEM_COUNT ? (
    <Paginator
      gotoPage={(number) => actions.setPageNumberAndGo(number, loadTable, tableType, searchParams)}
      pageCount={pageCount}
      pageNumber={pageNumber}
      pageSize={tablePageSize}
      insideModal={insideModal}
      setPageSize={setPageSizeInStoreAndTable}
    />
  ) : null;
};

export default Pagination;
